import {
  BackButton,
  Container,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { FunctionComponent, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { resendOtpCode, verifyOtpCode } from '../../../common/api/organization';
import { ApiError } from '../../../common/api/types';
import { addToast } from '../../../common/reducers/toasterSlice';
import { VerifyOTPCard } from '../VerifyOTPCard/VerifyOTPCard';

export const VerifyBusiness: FunctionComponent = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { organizationId = '' } = useParams();

  const onVerifyPressed = useCallback(async (code: string) => {
    try {
      const { success } = await verifyOtpCode(organizationId, code);
      if (!success) {
        dispatch(
          addToast({
            message: `Invalid verification code entered`,
            isError: true,
          })
        );

        return;
      }

      dispatch(
        addToast({
          message: 'Organization succesfully validated!',
        })
      );

      navigate(`/organization/${organizationId}/success`);
    } catch (e) {
      let message = 'An error occured while verifying OTP code';

      if (e instanceof ApiError) {
        message = e.response.error.description;
      }

      dispatch(
        addToast({
          message,
          isError: true,
        })
      );
    }
  }, []);

  const onResendPressed = useCallback(async () => {
    try {
      await resendOtpCode(organizationId);
      dispatch(
        addToast({
          message: `OTP email has been sent`,
        })
      );
    } catch (e) {
      let message = 'An error occured while requesting an OTP code';
      if (e instanceof ApiError) {
        message = e.response.error.description;
      }

      dispatch(
        addToast({
          message,
          isError: true,
        })
      );
    }
  }, []);

  return (
    <Page>
      <Container size="medium">
        <div className="flex flex-row items-center gap-x-3 mb-os1-spacing">
          <BackButton />
          <PageTitle>Verify Business Email</PageTitle>
        </div>
        <VerifyOTPCard
          actionTitle="Verify Company Email"
          onResendPressed={onResendPressed}
          onVerifyPressed={onVerifyPressed}
        />
      </Container>
    </Page>
  );
};
